export const appointmentConfigReducer = (state = {}, action) => {
    switch (action.type) {
        // CONFIG – ADD
        case "ADD_HOME_VISIT_CONFIG_REQUEST":
            return {
                ...state,
                loading: true,
                addConfig: null,
            };
        case "ADD_HOME_VISIT_CONFIG_SUCCESS":
            return {
                ...state,
                loading: false,
                addConfig: action.payload,
            };
        case "ADD_HOME_VISIT_CONFIG_FAILED":
            return {
                ...state,
                loading: false,
                addConfig: action.payload,
            };


        // CONFIG – UPDATE
        case "UPDATE_HOME_VISIT_CONFIG_REQUEST":
            return {
                ...state,
                loading: true,
                updateConfig: null,
            };
        case "UPDATE_HOME_VISIT_CONFIG_SUCCESS":
            return {
                ...state,
                loading: false,
                updateConfig: action.payload,
            };
        case "UPDATE_HOME_VISIT_CONFIG_FAILED":
            return {
                ...state,
                loading: false,
                updateConfig: action.payload,
            };


        // CONFIG – DELETE
        case "DELETE_HOME_VISIT_CONFIG_REQUEST":
            return {
                ...state,
                loading: true,
                deleteConfig: null,
            };
        case "DELETE_HOME_VISIT_CONFIG_SUCCESS":
            return {
                ...state,
                loading: false,
                deleteConfig: action.payload,
            };
        case "DELETE_HOME_VISIT_CONFIG_FAILED":
            return {
                ...state,
                loading: false,
                deleteConfig: action.payload,
            };


        // CONFIG – VIEW
        case "VIEW_HOME_VISIT_CONFIG_REQUEST":
            return {
                ...state,
                loading: true,
                viewConfig: null,
            };
        case "VIEW_HOME_VISIT_CONFIG_SUCCESS":
            return {
                ...state,
                loading: false,
                viewConfig: action.payload,
            };
        case "VIEW_HOME_VISIT_CONFIG_FAILED":
            return {
                ...state,
                loading: false,
                viewConfig: action.payload,
            };


        // PAYMENTS LIST
        case "GET_HOME_VISIT_PAYMENTS_REQUEST":
            return {
                ...state,
                loading: true,
                payments: null,
            };
        case "GET_HOME_VISIT_PAYMENTS_SUCCESS":
            return {
                ...state,
                loading: false,
                payments: action.payload,
            };
        case "GET_HOME_VISIT_PAYMENTS_FAILED":
            return {
                ...state,
                loading: false,
                payments: action.payload,
            };

        case "GET_HOME_VISIT_CONFIGS_LIST_REQUEST":
            return {
                ...state,
                loading: true,
                configsList: null,
            };
        case "GET_HOME_VISIT_CONFIGS_LIST_SUCCESS":
            return {
                ...state,
                loading: false,
                configsList: action.payload,
            };
        case "GET_HOME_VISIT_CONFIGS_LIST_FAILED":
            return {
                ...state,
                loading: false,
                configsList: action.payload,
            };
            
        default:
            return state;
    }
};
